import React, { Component } from 'react'
import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'
import Form from 'ui/components/Form.js'
import './styles.css'

export default class Key extends Component {
    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.state = {
            accessGained: false,
            ready: false
        }
    }

    componentDidMount() {
        const { id } = this.props
        this.storageChecker(id)
        console.log(Form)
    }

    storageChecker = (id) => {
        let name = localStorage.getItem("name")
        let email = localStorage.getItem("email")
        let formId = localStorage.getItem("formId")

        if (formId && email && name && name !== "" && email !== "" && formId !== "") {
            if (formId === id) { this.setState({ accessGained: true, ready: true }) }
        } else {
            this.setState({ ready: false })
        }
    }

    handleCallback = (a) => {
        if (a) {
            this.setState({ ready: true })
        }
    }

    render() {
        const {
            id, bodyText
        } = this.props

        const { accessGained, ready } = this.state

        return (
            <Wrapper>
                <Overlay visibility={accessGained === true ? "true" : undefined}>
                        <Popup size={bodyText ? 'undefined' : 'center'} className={`example-element ${ready ? 'show' : 'hide'}`}>
                            {bodyText &&
                                <Text dangerouslySetInnerHTML={{ __html: bodyText }}></Text>
                            }
                            <FormWrapper size={bodyText ? '50%' : '80%'} ref={this.formRef}>
                                  <Form
                                    id={id}
                                    parentCallback={this.handleCallback}
                                ></Form>  
                                {!ready &&
                                    <Placeholder>
                                        <Spinner className='loader' />
                                    </Placeholder>
                                }
                            </FormWrapper>
                        </Popup>
                </Overlay>
            </Wrapper>
        )
    }
}

const Wrapper = styled.div`
z-index: 11111111;
background-color: red;
`
const Overlay = styled.div`
display: ${props => props.visibility === "true" ? 'none' : 'flex'}
background-color: rgba(255,255,255,0.5);
position: absolute;
width: 100vw;
height: 100vh;
z-index: 2;
backdrop-filter: blur(10px);
justify-content: center;
align-items: center;
`
const Placeholder = styled.div`

text-align: center;

.loader,
.loader:after {
  border-radius: 50%;
  width: 5em;
  height: 5em;
}
.loader {
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 0.7em solid rgba(255, 255, 255, 0.2);
  border-right: 0.7em solid rgba(255, 255, 255, 0.2);
  border-bottom: 0.7em solid rgba(255, 255, 255, 0.2);
  border-left: 0.7em solid #004077;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}


`
const Spinner = styled.div`

`

const Popup = styled.div`
display: flex;
width: 100%;
background-color: rgb(245,245,245);
padding: 2% 2%;
flex-wrap: wrap;
justify-content: ${props => props.size}
${media.md`
width: 50%;
`}
${media.xl`
width: 33%;
`}
`
const Text = styled.div`
width: 100%;
${media.md`
width: 50%;
`}
`
const FormWrapper = styled.div`
width: 100%;
transistion: all 2s;

${media.md`
width: ${props => props.size};
`}
`


// WEBPACK FOOTER //
// ./src/ui/components/modules/Key/index.js